import { OUTLOOK_AU_INTRO, OUTLOOK_AU_SLUG } from '@/content/outlookAutomotive'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The tenth report with a designed page of its own, and the first Future 2030
  // outlook to get one — asked for on 2026-08-28 (*"referans alarak ilgili
  // sayfayı tasarla"*) with a four-part full-page capture of the live page and
  // all six of the images it carries. See `content/outlookAutomotive.ts` and
  // `pages/OutlookAutomotive.tsx`.
  ...outlook(
    OUTLOOK_AU_SLUG,
    'Automotive',
    undefined,
    'future-2030-outlook-automotive-cover',
    'ddfd8dd7-f90f-4229-9d8b-dd9016923a24-Future 2030 Digital Transformation Outlook for the Automotive Industry.pdf',
  ),
  // The hero's own two lines, joined into one paragraph. Unlike the designed
  // focus pages this page draws its hero from `OUTLOOK_AU_INTRO` directly, so
  // `body` feeds exactly one thing: the meta description `prerender.tsx` takes
  // from `body[0]`. Both sentences together are the description; the promise
  // alone is too short to be one.
  body: [`${OUTLOOK_AU_INTRO.lede} ${OUTLOOK_AU_INTRO.body}`],
  layout: 'automotive-outlook',
  // Its own words, its cover, its file and all six of its images, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `outlookAutomotiveChecks()` carries that
  // into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 30
